
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';

import { FILESERVICE } from '@/config/defaultSetting';

export default defineComponent({
  name: 'ErrorPage',
  setup() {
    const router = useRouter();

    function goBack() {
      router.back();
    }

    function goHome() {
      router.push({ path: '/home' });
    }
    return {
      goHome,
      goBack,
      FILESERVICE,
    };
  },
});
